import { OfflineTerminalConnection } from './offlineTerminalTypes';

/** Shape from getCardBizEcr GraphQL query */
export type CardBizEcrRecord = {
	deviceIP?: string | null;
	devicePort?: string | null;
	terminalId?: string | null;
	isDefault?: boolean | null;
	isActive?: boolean | null;
};

/** Pick default terminal for outlet, else first active row */
export function getDefaultCardBizEcr(
	records?: CardBizEcrRecord[] | null,
): CardBizEcrRecord | undefined {
	const active = (records ?? []).filter(r => r.isActive !== false);
	return active.find(r => r.isDefault) ?? active[0];
}

/**
 * Terminal IP/port from MenuX database (p_cardBizEcr).
 * Replaces outlets.json / config.json per-outlet IP.
 */
export function getOutletEcrTerminal(
	cardBizEcrList?: CardBizEcrRecord[] | null,
): OfflineTerminalConnection | undefined {
	const row = getDefaultCardBizEcr(cardBizEcrList);
	if (!row?.deviceIP) {
		return undefined;
	}
	return {
		host: row.deviceIP,
		port: row.devicePort ? Number(row.devicePort) : 8800,
		terminalId: row.terminalId ?? undefined,
	};
}

export function buildEcrPayRequest(params: {
	amount: number;
	transactionId: string;
	outletId: string;
	paymentMethod?: 'CARD' | 'EWALLET' | 'QR';
	cardBizEcrList?: CardBizEcrRecord[] | null;
}) {
	const terminal = getOutletEcrTerminal(params.cardBizEcrList);
	return {
		amount: params.amount,
		transactionId: params.transactionId,
		outletId: params.outletId,
		paymentMethod: params.paymentMethod || 'CARD',
		...(terminal ? { terminal } : {}),
	};
}

export function buildEcrVoidRequest(params: {
	transactionId: string;
	outletId: string;
	amount?: number;
	approvalCode?: string;
	invoiceNumber?: string;
	terminalId?: string;
	cardBizEcrList?: CardBizEcrRecord[] | null;
}) {
	const terminal = getOutletEcrTerminal(params.cardBizEcrList);
	return {
		transactionId: params.transactionId,
		outletId: params.outletId,
		amount: params.amount,
		approvalCode: params.approvalCode,
		invoiceNumber: params.invoiceNumber,
		terminalId: params.terminalId,
		...(terminal ? { terminal } : {}),
	};
}
